// Chart libraries need literal colours; these mirror the light-mode tokens in styles/tokens.css.
export const colors = {
  ok: '#5ec281',
  warn: '#ee8a2f',
  danger: '#ed524e',
  info: '#2b5bb7',
  accent: '#06727a',
  purple: '#8c7fd6',
  teal: '#2f9e95',
  neutral: '#b6b6b6',
  primary: '#6155cc',
  emphasis: '#ee7a5a',
}

// Lavender and teal lead; the rest alternate in hue so adjacent slices stay distinguishable.
export const categorical = [colors.purple, colors.teal, colors.emphasis, colors.primary, colors.warn, colors.info, colors.ok, colors.danger]
